import React from 'react'
import styled from 'styled-components'
import {
  POLICY_NAVBAR_ITEM_LABEL_WIDTH_MOBILE,
  POLICY_ROOT_MENU_HEIGHT,
} from 'consts'
import {getFontFamily} from 'utils'
import convertUnit from 'lib/unit'
import {Paragraph} from 'common/components'
import {PolicyRootTopNavBarItemProps} from './PolicyRootTopNavBarItemProps'

interface StyledContainerProps {
  isSelected: boolean
  showLabel?: boolean
}

const StyledContainer = styled.div<StyledContainerProps>`
  display: flex;
  width: ${convertUnit(POLICY_NAVBAR_ITEM_LABEL_WIDTH_MOBILE)};
  box-sizing: border-box;
  justify-content: space-between;
  border-radius: ${convertUnit(10)};
  margin: ${convertUnit(5)} ${convertUnit(18)};
  min-height: ${convertUnit(POLICY_ROOT_MENU_HEIGHT)};
  align-items: center;
  direction: ltr;
  :hover {
    cursor: pointer;
  }
  transition: all 0.15s ease-out;
`

const StyledLabel = styled(Paragraph)<StyledContainerProps>`
  ${({isSelected, theme}) =>
    isSelected
      ? {
          color: theme.primary_5,
          fontFamily: getFontFamily('quicksandBold'),
        }
      : {
          color: theme.gray_5,
          fontFamily: getFontFamily('quicksandMedium'),
          ':hover': {
            color: theme.primary_5,
          },
        }}
  text-align: center;
  width: 100%;
  box-sizing: border-box;
`

export default function PolicyRootTopNavBarItem({
  isSelected,
  label,
  onClick,
}: PolicyRootTopNavBarItemProps) {
  return (
    <StyledContainer
      isSelected={isSelected}
      onClick={isSelected ? undefined : onClick}>
      <StyledLabel
        isSelected={isSelected}
        fontWeight={isSelected ? 'quicksandBold' : 'quicksandMedium'}>
        {label}
      </StyledLabel>
    </StyledContainer>
  )
}
